/* tslint:disable:no-string-literal */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/app';
import configureStore from './configureStore';
import registerServiceWorker from './registerServiceWorker';
import { InitialState } from './store/reducers';
import { IAdvancedPreview } from './store/types';

const defaultStore = configureStore(InitialState);

const AP: IAdvancedPreview = {
  open: (mediaId: number, rootNodeId: string) => {
    InitialState.timeline.parentMediaId = mediaId;
    const store = configureStore(InitialState);

    startReact(rootNodeId, store);
  }
};

// wrapper for ReactDOM.render() call
const startReact = (rootNode = 'root', store = defaultStore) => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById(rootNode) as HTMLElement
  );
};

// we can remove this after we migrate mvision-html/MVision.UI to webpack
(() => {

  interface IWindow extends Window {
    mvision: {services: {AP_REQUIRED: boolean}};
    AP: IAdvancedPreview;
  }

  const localWindow = window as IWindow;

  const setGlobalAP = () => {
    // set AP as a global property
    localWindow.AP = AP;
  };

  const onDOMContentLoaded = (event: Event) => {
    // remove the event listener
    document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);

    const mvisionLoaded: boolean =
      typeof localWindow.mvision === 'object' &&
      typeof localWindow.mvision.services === 'object' &&
      localWindow.mvision.services.AP_REQUIRED;

    if (!mvisionLoaded) {
      // fallback to the "natural" react code
      startReact();
      registerServiceWorker();
      return;
    }

    setGlobalAP();
  };

  /**
   * If the document and the mvision.services namespace are already loaded
   * we set the global AP object...
   */
  if (document.readyState === 'complete') {
    const mvisionLoaded: boolean =
      typeof localWindow.mvision === 'object' &&
      typeof localWindow.mvision.services === 'object' &&
      localWindow.mvision.services.AP_REQUIRED;

    if (mvisionLoaded) {
      setGlobalAP();
    }
  } else {
    // ...otherwise we listen for the document to be ready
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
  }
})();

export default AP;



// WEBPACK FOOTER //
// ./src/index.tsx